export default "__VITE_ASSET__C2zYqY1I__"